import { render, staticRenderFns } from "./AddStore.vue?vue&type=template&id=40f70182&scoped=true"
import script from "./AddStore.vue?vue&type=script&lang=js"
export * from "./AddStore.vue?vue&type=script&lang=js"
import style0 from "./AddStore.vue?vue&type=style&index=0&id=40f70182&prod&lang=less&scoped=true"
import style1 from "./AddStore.vue?vue&type=style&index=1&id=40f70182&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f70182",
  null
  
)

export default component.exports